import React, { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet-async';
import { makePhotoUrl } from '../../utils/makePhotoUrl';
import { useNotNullableContext } from '../../hooks/useNotNullableContext';
import { PageMetaContext } from '../../context/PageMetaContext';
import useBasePageQuery from '../../hooks/useBasePageQuery';

const InMemoryHelmet: FunctionComponent = () => {
  const basePageData = useBasePageQuery();
  const { currentUrl } = useNotNullableContext(PageMetaContext);

  if (!basePageData.data?.page) {
    return null;
  }

  const { title, hero } = basePageData.data.page;

  return (
    <Helmet
      title={title}
      meta={[
        { property: 'og:title', content: title },
        {
          property: 'og:image',
          content:
            hero?.imageUrl ||
            makePhotoUrl('imo-lilies.jpg.jpg', 'CampaignHeroMedium'),
        },
        { property: 'og:url', content: currentUrl },
        { property: 'twitter:card', content: 'summary_large_image' },
        { property: 'og:site_name', content: 'Just Giving' },
      ]}
    />
  );
};

export default InMemoryHelmet;
